import type { BadgeTone } from '@/components/ui/badge'
import type { Tone } from './types'

export const includesTr = (hay: string, needle: string) => hay.toLocaleLowerCase('tr').includes(needle.trim().toLocaleLowerCase('tr'))

export const TONE_BADGE: Record<Tone, BadgeTone> = { primary: 'primary', info: 'info', success: 'success', warning: 'warning', danger: 'danger', neutral: 'neutral' }

export const TONE_DOT: Record<Tone, string> = {
  primary: 'bg-primary',
  info: 'bg-info',
  success: 'bg-success',
  warning: 'bg-warning',
  danger: 'bg-destructive',
  neutral: 'bg-muted-foreground/50',
}
